import { useMutation, useQueryClient } from '@tanstack/react-query';

import { displayToastError } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateSeniorityRelatedQueries } from '@/modules/common/utils/query-invalidation';
import { updateSeniorities } from '@/modules/settings/api/seniorities.api';
import { UpsertSeniorityRequestItem } from '@/modules/settings/types/request/seniority-request';

/**
 * Hook to update seniorities in bulk (create new, update existing).
 * Invalidates seniority queries and team member queries (which use seniorities as dropdown options).
 */
export const useUpdateSeniorities = () => {
  const queryClient = useQueryClient();
  const { getErrorMessage } = useApiError();

  return useMutation({
    mutationFn: (seniorities: UpsertSeniorityRequestItem[]) => updateSeniorities(seniorities),
    onSuccess: async () => {
      // Invalidate seniority and team member queries
      await invalidateSeniorityRelatedQueries(queryClient);
    },
    onError: (error: unknown) => {
      displayToastError(getErrorMessage(error, true));
    },
  });
};
